<!-- 巡检概览 -->
<template>
  <div class="m-panel">
    <div class="center-content">
      <div class="center-box">
        <div class="center-item" v-for="item in list" :key="item.title">
          <div class="title">{{ item.title }}</div>
          <div class="num">{{ item.num }}</div>
          <div class="hb">{{ $t('近七日抄见率{rate}%', { rate: item.hb }) }}</div>
        </div>
        <div class="bottom-img">
          <img src="@/assets/xj3.png" alt="" />
        </div>
      </div>
    </div>
    <div class="base-box">
      <div class="base-item" v-for="item in list1" :key="item.title">
        <div class="base-text">
          <div class="num">
            <i>{{ item.num }}</i>
          </div>
          <div class="title">{{ item.title }}</div>
        </div>
        <div class="base-img">
          <img src="@/assets/xj4.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { postAction,putAction } from '@/api/manage'
export default {
  data() {
    return {
      title: this.$t('本月任务'),
      url: {
        list: '/jeecg-charge/meter/waterAnalysis/meterReportingRate',
      },
      list: [
        { title: this.$t('水表总数'), num: 0, hb: 0 },
        { title: this.$t('远传表数'), num: 0, hb: 0 },
        { title: this.$t('非远传表数'), num: 0, hb: 0 },
      ],
      list1: [
        { title: this.$t('开阀数'), num: 0 },
        { title: this.$t('关阀数'), num: 0 },
      ],
    }
  },
  methods: {
    init() {
      this.getlist();
    },
    getlist(){
      putAction(this.url.list, {}).then((res) => {
          if(res.success){
              this.list1[0].num = res.result.meterValveOpenCount
              this.list1[1].num = res.result.meterValveCloseCount
              this.list[0].num = res.result.meterTotalCount
              this.list[0].hb = Number(((res.result.lastThreeDayMeterReportCount/res.result.meterTotalCount)*100).toFixed(0))
              this.list[1].num = res.result.meterTotalCount
              this.list[1].hb = Number(((res.result.lastSevenDayMeterReportCount/res.result.meterTotalCount)*100).toFixed(0))
          }
      })
    }
  },
}
</script>
  
  <style scoped lang="less">
.base-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  height: 35%;

  .base-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 18%;
    height: 100%;
    position: relative;

    .base-img {
      width: 100%;
      height: 120%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .base-text {
      text-align: center;
      font-size: 18px;
      z-index: 99;
      position: absolute;
      top: 35%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;

      .num {
        font-size: 25px;
        font-family: fantasy;
      }
    }
  }
}
.center-content {
  height: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  .center-box {
    display: flex;
    justify-content: space-evenly;
    // height: 70%;
    width: 100%;
    .center-item {
      width: 25%;
      text-align: center;
      border: 1px solid #00fafe;
      padding: 20px 10px;
      border-radius: 2px;
      .title {
        font-size: 20px;
        color: aqua;
      }
      .hb {
        height: 21px;
        font-size: 14px;
        color: yellowgreen;
      }
      .num {
        font-family: 'ds-digital-bold';
        color: #fff;
        font-size: 45px;
      }
    }
  }
  .bottom-img {
    position: absolute;
    z-index: 99;
    top: 45%;
    left: 50%;
    transform: translate(-50%, 0%);
  }
}
</style>